import React from 'react';
import { ScrollView, View, useWindowDimensions } from 'react-native';
import { useRightPanelSlot } from './RightPanelSlotContext';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';

const MIN_WIDTH = 1180;

/**
 * Whether the window is wide enough for the large-screen right panel, so a screen can show
 * its right-panel content inline instead when it isn't.
 */
export function useIsRightPanelVisible() {
  const { width } = useWindowDimensions();
  const isLargeScreen = useIsLargeScreen();
  return isLargeScreen && width >= MIN_WIDTH;
}

export function LargeScreenRightPanel() {
  const isVisible = useIsRightPanelVisible();
  const { content, width } = useRightPanelSlot();

  if (!isVisible || !content) {
    return null;
  }

  return (
    <View className={`${width === 'wide' ? 'w-[30rem]' : 'w-96'} bg-background-0`}>
      <ScrollView className="pb-10 pt-7">
        <View className="px-6">{content}</View>
      </ScrollView>
    </View>
  );
}
